import { ReactElement } from 'react'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUsers, faGlobe } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from '@lingui/macro'
import Button from 'Root/App/Button'
import Paragraph from 'Root/App/Paragraph'
import PreTitle from 'Root/App/PreTitle'
import Title from 'Root/App/Title'
import { getPricingPageURL } from 'lib/get-pricing-page-url'
import getQueryString from 'lib/get-query-string'
import { useRouter } from 'next/router'

import Chip from '../Chip'

library.add(faUsers, faGlobe)

interface BuyToShareProProps {
  active?: boolean
  description: string | ReactElement
  iconType: 'users' | 'globe'
  onClick?: () => void
  title: string | ReactElement
}

const BoxIcon = ({ type }) => (
  <span className="flex justify-center items-center bg-gray-200 w-10 h-10 min-w-10 rounded-lg">
    <FontAwesomeIcon className="text-lg text-gray-500" icon={['fas', type]} />
  </span>
)

const BuyToSharePro = ({
  active,
  description,
  iconType,
  onClick,
  title,
}: BuyToShareProProps) => {
  const { query } = useRouter()

  return (
    <Chip
      icon={<BoxIcon type={iconType} />}
      highlight
      highlightCustomClass="p-3 flex-col gap-y-3 sm:flex-1 cursor-default"
      active={active}
      onClick={onClick}
    >
      <span className="flex flex-col gap-y-1 h-full">
        <Title className="flex items-center gap-3" size="2XS">
          {title}
          <PreTitle className="p-1 bg-gray-900 text-white rounded">
            PRO
          </PreTitle>
        </Title>
        <Paragraph className="text-gray-500 sm:max-w-sm sm:w-auto">
          {description}
        </Paragraph>
        <span className="flex flex-col gap-1 mt-5 justify-end h-full">
          <Button anchor to={getPricingPageURL(getQueryString(query.locale))}>
            <Trans>Prova gratis per 14 giorni</Trans>
          </Button>
        </span>
      </span>
    </Chip>
  )
}

export default BuyToSharePro
